module.exports = __webpack_public_path__ + "static/media/47_B.f2b15457.png";